import { createApp, watch, reactive } from 'vue'

// global utilities
import Toast from '@utils/Toast.js'
window.Toast = Toast

import Prompt from '@utils/Prompt'
window.Prompt = Prompt

// Create app
import MainApp from '@views/Main.vue'
const app = createApp(MainApp)

// State management
import { createPinia } from 'pinia/dist/pinia.mjs'
app.use(createPinia())

// Use router
import router from '@routes'
app.use(router)

// impor chartjs
import { Chart as ChartJS, CategoryScale, BarElement, ArcElement, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js'
ChartJS.register(CategoryScale, BarElement, ArcElement, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

// Mount
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('#prebook-admin-app')) app.mount('#prebook-admin-app')
})

// Global properties
app.config.globalProperties.Image = (path) => {
    return prebook_admin.url.assets + 'images/' + path
}

// Debug
function Log() {
    if (!prebook_admin.debug) return
    const args = Array.prototype.slice.call(arguments)
    console.log('%c[Prebook]', 'background: purple; color: #fff; font-size: 10px; padding: 1px 2px; border-radius: 3px', ...args)
}

window.Log = Log
app.config.globalProperties.Log = Log

import { updateMediaQueries } from '@utils/mediaQuery'
updateMediaQueries()

// Ability
import ability from '@utils/Ability'
window.ability = ability

import { usePermission } from '@store/permission'
const $permission = usePermission()

$permission.initPermissions()

localStorage.setItem('userType', window.prebook_admin.profile.role)

function access(action, subject = localStorage.getItem('userType')) {
    return ability.can(action, subject)
}

window.access = access
app.config.globalProperties.access = access

// Note: do not change this code. in ref, reactive and computed, it will not work in input as expected
const customizer = prebook_admin.settings.customizer

window.customizer = customizer
app.config.globalProperties.customizer = customizer

localStorage.setItem('customizer', JSON.stringify(customizer))


// rtl
import { useSettings } from '@store/settings'
const $settings = useSettings()

document.addEventListener('DOMContentLoaded', () => {
    if ($settings.isRTL) {
        document.querySelector('html').setAttribute('dir', 'rtl')
    }
})